import React, { useState, useEffect } from 'react';
import { Menu, X, MapPin, Phone, Mail, Calendar, Users,Navigation , Utensils, Mountain, Star, ChevronLeft, ChevronRight, Globe } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Home = () => {
    const navigate = useNavigate(); // ✅ define it here
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [language, setLanguage] = useState('fr');
  const [scrolled, setScrolled] = useState(false);

  const content = {
    fr: {
      hero: {
        title: 'Riad Lina',
        subtitle: 'Entrez & découvrez notre Riad a Tafraoute',
        cta: 'Réserver Maintenant',
        
      },
      about: {
        title: 'Authenticité & Sérénité',
        desc: 'Un séjour authentique dans la vallée d’ammelne Pour que votre séjour soit inoubliable Le Riad lina a l’atmosphère unique et plein de charme ravira vos sens pour un séjour authentique au maroc Situé au coeur de la vallée d’ammelne et en face de la tete de lion nous vous accueillons pour un séjour inoubliable'
      },
      rooms: {
        title: 'notre Riad a Tafraoute',
        subtitle: 'Une expérience unique au cœur de la vallée d’ammelne proche de tafraout au Maroc',
        types: [
          { name: 'Ambiance ', desc: 'Entrez dans notre riad et laissez vous imprégner de notre décoration ethnic-chic berbère au chaque détail à été minutieusement choisi', price: '180€', guests: '2-3' ,img:'/img/image14.jpeg' },
          { name: 'Detente', desc: 'Rafraîchissez-vous dans notre piscine et prenez le temps de vous reposer dans nos salons… vous êtes en vacances', price: '120€', guests: '2' ,img:'/img/image20.jpeg' },
          { name: 'Nos chambres', desc: 'Au pied des montagnes nos chambres à la literie confortable et à la décoration soignée vous offrant une parenthèse de calme et d’authenticité lors de votre séjour au Maroc', price: '80€', guests: '2' ,img:'/img/image10.jpeg' },
          { name: 'S’émerveiller', desc: 'Vue magique sur la vallée d’ammelne et les montagnes de l’anti atlas depuis notre terrasse… contempler un coucher de soleil… rêver la tete sous les étoiles', price: '120€', guests: '2' ,img:'/img/image13.jpeg' }

        ]
        
      },
      restaurant: {
        title: 'Découvrez nos chambres ',
        subtitle: 'chambres à la décoration ethnic-chic entièrement climatisées',
        desc: '10 chambres à la décoration ethnic-chic entièrement climatisées Découvrez nos chambres Possibilité de privatiser notre Riad sur la base de 15 personnes en demi-pension a partir de 600 €/jour'
      },
      excursions: {
        title: 'Excursions Uniques',
        subtitle: 'Explorez Tafraoute',
        list: ['Randonnées dans la vallée des Ameln', 'Excursions dans les Gorges d\'Ait Mansour', 'Excursions dans le désert depuis le Riad Lina – Tafraoute', 'Service de navette Aéroport – Riad Lina']
      },
      contact: {
        title: 'Réservez Votre Séjour',
        address: 'TANDILT-AMMELNE-TAFROUT',
        phone: '+212 667 624183',
        whatssap: '+212 667 624183',
        email: 'CONTACT@RAIDLINA.MA'
      },
      address: {
      subtitle: 'NOTRE ADRESSE',
      title1: 'RIAD LINA',
      title2: 'TANDILT-AMMELNE-TAFROUT',
      desc: "Maison d’hôtes au Maroc – TANDILT-AMMELNE-TAFROUT, 45000 Maroc",
      button: "Plan d'accès",
    },
    locationTitle: 'Notre Emplacement',
      locationDesc: 'Niché dans la magnifique vallée d\'Ammelne, le Riad Lina bénéficie d\'un emplacement exceptionnel avec vue panoramique sur les montagnes de l\'Anti-Atlas.',
      directionsTitle: 'Comment Nous Trouver',
      directions: [
        'À 180 km d\'Agadir (2h30 en voiture)',
        'À 90 km de Tiznit (1h30 en voiture)',
        'Au cœur de Tafraoute, facilement accessible',
        'Parking gratuit disponible'],
    reserve: {
      subtitle: 'RÉSERVER UNE CHAMBRE',
      title1: 'Séjournez dans notre',
      title2: "Maison d'hôtes",
      desc: "Majid et son équipe auront le plaisir de vous accueillir au RIAD LINA et veilleront à ce que votre séjour soit inoubliable.",
      button: 'Réservez votre séjour',
    }
    ,
    },    
  };

  const t = content[language];
  const images = [
    'img/bg2.jpg',
    'img/bg1.jpg',
    'img/bg6.jpg'
  ];
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % images.length);
  const prevSlide = () => setCurrentSlide((prev) => (prev - 1 + images.length) % images.length);

  return (
    <div style={{ fontFamily: 'Georgia, serif', overflow: 'hidden' }}>
      <style>{`
        @import url('/img/bg3.jpg');
        
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body { font-family: 'Lora', serif; color: #2c2c2c; }
        
        .fade-in { animation: fadeIn 1s ease-in; }
        @keyframes fadeIn { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }
        
        .slide-in-left { animation: slideInLeft 0.8s ease-out; }
        @keyframes slideInLeft { from { opacity: 0; transform: translateX(-100px); } to { opacity: 1; transform: translateX(0); } }
        
        .slide-in-right { animation: slideInRight 0.8s ease-out; }
        @keyframes slideInRight { from { opacity: 0; transform: translateX(100px); } to { opacity: 1; transform: translateX(0); } }
        
        .scale-in { animation: scaleIn 0.6s ease-out; }
        @keyframes scaleIn { from { opacity: 0; transform: scale(0.9); } to { opacity: 1; transform: scale(1); } }
        
        .float { animation: float 6s ease-in-out infinite; }
        @keyframes float { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-20px); } }
        
        .hover-lift { transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1); }
        .hover-lift:hover { transform: translateY(-15px); box-shadow: 0 25px 50px rgba(0,0,0,0.2); }
        
        .shine { position: relative; overflow: hidden; }
        .shine::before {
          content: ''; position: absolute; top: 0; left: -100%; width: 100%; height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
          transition: left 0.5s;
        }
        .shine:hover::before { left: 100%; }
        
        .gold-gradient { background: linear-gradient(135deg, #d4af37 0%, #f9e79f 50%, #d4af37 100%); }
        .text-gold { color: #d4af37; }
        
        .pattern-overlay {
          background-image: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
        }
        
        .parallax-bg { background-attachment: fixed; background-position: center; background-repeat: no-repeat; background-size: cover; }
      `}</style>
      {/* Hero Section */}
      <section style={{ position: 'relative', height: '100vh', overflow: 'hidden' }}>
        {images.map((img, i) => (
          <div key={i} style={{
            position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
            backgroundImage: `url(${img})`, backgroundSize: 'cover', backgroundPosition: 'center',
            opacity: currentSlide === i ? 1 : 0, transition: 'opacity 1.5s ease-in-out'
          }} />
        ))}
        
        <div style={{
          position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
          background: 'linear-gradient(to bottom, rgba(0,0,0,0.4), rgba(0,0,0,0.6))'
        }} className="pattern-overlay" />

        <div style={{
          position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
          textAlign: 'center', color: '#fff', width: '90%', maxWidth: '900px'
        }} className="fade-in">
          <h1 style={{
            fontFamily: 'Playfair Display, serif', fontSize: 'clamp(48px, 8vw, 90px)',
            fontWeight: 700, marginBottom: '25px', letterSpacing: '3px',
            textShadow: '2px 2px 20px rgba(0,0,0,0.5)'
          }} className="float">
            {t.hero.title}
          </h1>
          <div style={{
            width: '150px', height: '3px', margin: '0 auto 30px',
            background: 'linear-gradient(90deg, transparent, #d4af37, transparent)'
          }} />
          <p style={{
            fontSize: 'clamp(20px, 3vw, 32px)', marginBottom: '50px',
            fontFamily: 'Playfair Display, serif', fontStyle: 'italic',
            textShadow: '1px 1px 10px rgba(0,0,0,0.5)', letterSpacing: '1px'
          }}>
            {t.hero.subtitle}
          </p>
          {/* 00000000000000000000000test */}
          <button style={{
            background: 'linear-gradient(135deg, #d4af37, #f9e79f)',
            color: '#000', padding: '18px 50px', fontSize: '18px',
            border: 'none', borderRadius: '50px', cursor: 'pointer',
            fontWeight: 700, letterSpacing: '2px', transition: 'all 0.4s',
            boxShadow: '0 10px 40px rgba(212, 175, 55, 0.4)',
            fontFamily: 'Playfair Display, serif'
          }} className="shine"   onClick={() => navigate('/contact')}
             onMouseEnter={e => { e.target.style.transform = 'scale(1.1)'; e.target.style.boxShadow = '0 15px 50px rgba(212, 175, 55, 0.6)'; }}
             onMouseLeave={e => { e.target.style.transform = 'scale(1)'; e.target.style.boxShadow = '0 10px 40px rgba(212, 175, 55, 0.4)'; }}>
            {t.hero.cta}
          </button>
        </div>

        <button onClick={prevSlide} style={{
          position: 'absolute', left: '30px', top: '50%', transform: 'translateY(-50%)',
          background: 'rgba(212, 175, 55, 0.3)', border: '2px solid #d4af37',
          color: '#d4af37', padding: '15px', borderRadius: '50%', cursor: 'pointer',
          backdropFilter: 'blur(5px)', transition: 'all 0.3s'
        }}>
          <ChevronLeft size={28} />
        </button>
        <button onClick={nextSlide} style={{
          position: 'absolute', right: '30px', top: '50%', transform: 'translateY(-50%)',
          background: 'rgba(212, 175, 55, 0.3)', border: '2px solid #d4af37',
          color: '#d4af37', padding: '15px', borderRadius: '50%', cursor: 'pointer',
          backdropFilter: 'blur(5px)', transition: 'all 0.3s'
        }}>
          <ChevronRight size={28} />
        </button>
      </section>

      {/* About Section */}
      <section style={{ padding: '120px 30px', background: '#f8f5f0' }} className="slide-in-left">
        <div style={{ maxWidth: '1200px', margin: '0 auto', textAlign: 'center' }}>
          <h2 style={{
            fontFamily: 'Playfair Display, serif', fontSize: 'clamp(36px, 5vw, 56px)',
            color: '#2c2c2c', marginBottom: '30px', fontWeight: 700
          }}>
            {t.about.title}
          </h2>
          <div style={{ width: '100px', height: '3px', background: '#d4af37', margin: '0 auto 40px' }} />
          <p style={{
            fontSize: 'clamp(16px, 2vw, 20px)', lineHeight: '1.9', color: '#555',
            maxWidth: '900px', margin: '0 auto', fontWeight: 400
          }}>
            {t.about.desc}
          </p>
        </div>
      </section>

      {/* Rooms Section */}
      <section id="chambres" style={{
        padding: '120px 30px',
        background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)',
        color: '#fff'
      }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '80px' }} className="scale-in">
            <p style={{ color: '#d4af37', fontSize: '16px', letterSpacing: '3px', marginBottom: '15px', fontWeight: 600 }}>
              {t.rooms.subtitle}
            </p>
            <h2 style={{
              fontFamily: 'Playfair Display, serif', fontSize: 'clamp(36px, 5vw, 56px)',
              marginBottom: '20px', fontWeight: 700
            }}>
              {t.rooms.title}
            </h2>
            <div style={{ width: '100px', height: '3px', background: '#d4af37', margin: '0 auto' }} />
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
            gap: '40px'
          }}>
            {t.rooms.types.map((room, i) => (
              <div key={i} style={{
                background: 'linear-gradient(145deg, #252525, #1a1a1a)',
                borderRadius: '20px', overflow: 'hidden',
                boxShadow: '0 15px 40px rgba(0,0,0,0.5)',
                border: '1px solid rgba(212, 175, 55, 0.2)'
              }} className="hover-lift">
                <div style={{
                  height: '290px',
                  backgroundImage: `url(${room.img})`,
                   backgroundPosition: 'center',backgroundSize: 'cover'
                }} />
                <div style={{ padding: '35px' }}>
                  <h3 style={{
                    fontFamily: 'Playfair Display, serif', fontSize: '28px',
                    marginBottom: '15px', color: '#d4af37', fontWeight: 600
                  }}>
                    {room.name}
                  </h3>
                  <p style={{ fontSize: '16px', marginBottom: '25px', color: '#ccc', lineHeight: '1.7' }}>
                    {room.desc}
                  </p>
                  {/* <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '25px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#d4af37' }}>
                      <Users size={20} />
                      <span>{room.guests}</span>
                    </div>
                    <div style={{ fontSize: '32px', fontWeight: 700, color: '#d4af37', fontFamily: 'Playfair Display, serif' }}>
                      {room.price}
                    </div>
                  </div> 
                  <button style={{
                    width: '100%', padding: '15px', background: 'transparent',
                    border: '2px solid #d4af37', color: '#d4af37', borderRadius: '50px',
                    cursor: 'pointer', fontSize: '16px', fontWeight: 600,
                    letterSpacing: '1px', transition: 'all 0.3s'
                  }} onClick={() => navigate('/contact')}
                  onMouseEnter={e => { e.target.style.background = '#d4af37'; e.target.style.color = '#000'; }}
                     onMouseLeave={e => { e.target.style.background = 'transparent'; e.target.style.color = '#d4af37'; }}>
                    {t.hero.cta}
                  </button>*/}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Restaurant Section */}
      <section id="restaurant" style={{
        padding: '120px 30px',
        backgroundImage: 'url(/img/bg6.jpg)',
        backgroundSize: 'cover', backgroundPosition: 'center', backgroundAttachment: 'fixed',
        position: 'relative'
      }} className="parallax-bg">
        <div style={{
          position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
          background: 'rgba(0,0,0,0.75)'
        }} />
        <div style={{ position: 'relative', maxWidth: '1000px', margin: '0 auto', textAlign: 'center', color: '#fff' }} className="fade-in">
          <p style={{ color: '#d4af37', fontSize: '16px', letterSpacing: '3px', marginBottom: '15px', fontWeight: 600 }}>
            {t.restaurant.subtitle}
          </p>
          <h2 style={{
            fontFamily: 'Playfair Display, serif', fontSize: 'clamp(36px, 5vw, 56px)',
            marginBottom: '30px', fontWeight: 700
          }}>
            {t.restaurant.title}
          </h2>
          <div style={{ width: '100px', height: '3px', background: '#d4af37', margin: '0 auto 40px' }} />
          <p style={{ fontSize: 'clamp(16px, 2vw, 20px)', lineHeight: '1.9', maxWidth: '800px', margin: '0 auto' }}>
            {t.restaurant.desc}
          </p>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', marginTop: '50px', flexWrap: 'wrap' }}>
            {[1, 2, 3, 4].map(i => (
              <Star key={i} size={32} fill="#d4af37" color="#d4af37" />
            ))}
          </div>
        </div>
      </section>

      {/* Excursions Section */}
      <section id="excursions" style={{ padding: '120px 30px', background: '#f8f5f0' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }} className="slide-in-right">
          <div style={{ textAlign: 'center', marginBottom: '70px' }}>
            <p style={{ color: '#d4af37', fontSize: '16px', letterSpacing: '3px', marginBottom: '15px', fontWeight: 600 }}>
              {t.excursions.subtitle}
            </p>
            <h2 style={{
              fontFamily: 'Playfair Display, serif', fontSize: 'clamp(36px, 5vw, 56px)',
              color: '#2c2c2c', marginBottom: '20px', fontWeight: 700
            }}>
              {t.excursions.title}
            </h2>
            <div style={{ width: '100px', height: '3px', background: '#d4af37', margin: '0 auto' }} />
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '30px' }}>
            {t.excursions.list.map((exc, i) => {
              // Créer l'ID de l'excursion basé sur l'index
              const excursionIds = ['vallee-ameln', 'Les-Gorges-d’Aït-Mansour', 'Aventure-Saharienne', 'Transfert-VIP'];
              const excursionId = excursionIds[i] || 'vallee-ameln';
              
              return (
                <div 
                  key={i} 
                  onClick={() => navigate(`/excursions/${excursionId}`)}

                  style={{
                    background: '#fff', 
                    padding: '40px 30px', 
                    borderRadius: '15px',
                    boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                    textAlign: 'center', 
                    transition: 'all 0.4s',
                    border: '2px solid transparent',
                    cursor: 'pointer'
                  }} 
                  className="hover-lift"
                  onMouseEnter={e => e.currentTarget.style.borderColor = '#d4af37'}
                  onMouseLeave={e => e.currentTarget.style.borderColor = 'transparent'}
                >
                  <Mountain size={48} color="#d4af37" style={{ marginBottom: '20px' }} />
                  <h3 style={{
                    fontFamily: 'Playfair Display, serif', 
                    fontSize: '22px',
                    color: '#2c2c2c', 
                    fontWeight: 600
                  }}>
                    {exc}
                  </h3>
                  <div style={{
                    marginTop: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    color: '#d4af37',
                    fontSize: '14px',
                    fontWeight: 600
                  }}>
                    <span>Voir détails</span>
                    <ChevronRight size={16} />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
      

      {/* Section Adresse + Réservation */}
      <section
        style={{
          position: 'relative',
          overflow: 'hidden',
          background: 'linear-gradient(to bottom, #0a0a0a, #1a1a1a)',
        }}
      >
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
            maxWidth: '1400px',
            margin: '0 auto',
            gap: '0',
          }}
        >
          {/* Left Side - Réservation avec overlay */}
          <div
            style={{
              position: 'relative',
              minHeight: '400px',
              overflow: 'hidden',
            }}
          >
            {/* Background Image */}
            <div
              style={{
                position: 'absolute',
                inset: 0,
                backgroundImage: "url('img/image16.jpeg')",
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                filter: 'brightness(0.4)',
              }}
            />
            
            {/* Overlay décoratif */}
            <div
              style={{
                position: 'absolute',
                inset: 0,
                background: 'linear-gradient(135deg, rgba(212,175,55,0.2) 0%, rgba(0,0,0,0.8) 100%)',
              }}
            />

            {/* Contenu */}
            <div
              style={{
                position: 'relative',
                zIndex: 2,
                padding: '80px 50px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                height: '100%',
              }}
            >
              {/* Ligne décorative */}
              <div
                style={{
                  width: '60px',
                  height: '3px',
                  background: 'linear-gradient(90deg, #d4af37, transparent)',
                  marginBottom: '20px',
                }}
              />

              <h4
                style={{
                  letterSpacing: '3px',
                  fontSize: '13px',
                  color: '#d4af37',
                  textTransform: 'uppercase',
                  fontWeight: '400',
                  marginBottom: '15px',
                }}
              >
                {t.reserve.subtitle}
              </h4>

              <h2
                style={{
                  fontFamily: 'Playfair Display, serif',
                  fontSize: '48px',
                  lineHeight: '1.2',
                  margin: '0 0 30px 0',
                  color: '#fff',
                  fontWeight: '700',
                }}
              >
                {t.reserve.title1}
                <br />
                <span style={{ color: '#d4af37' }}>{t.reserve.title2}</span>
              </h2>

              <p
                style={{
                  fontSize: '17px',
                  lineHeight: '1.8',
                  color: '#e0e0e0',
                  maxWidth: '500px',
                  marginBottom: '40px',
                }}
              >
                {t.reserve.desc}
              </p>

              <button
                style={{
                  background: 'linear-gradient(135deg, #d4af37 0%, #f4d03f 100%)',
                  border: '2px solid #d4af37',
                  color: '#000',
                  padding: '16px 45px',
                  borderRadius: '50px',
                  cursor: 'pointer',
                  fontWeight: '700',
                  fontSize: '15px',
                  letterSpacing: '1px',
                  textTransform: 'uppercase',
                  transition: 'all 0.4s ease',
                  width: 'fit-content',
                  boxShadow: '0 8px 25px rgba(212,175,55,0.3)',
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'translateY(-3px)';
                  e.target.style.boxShadow = '0 12px 35px rgba(212,175,55,0.5)';
                  e.target.style.background = 'linear-gradient(135deg, #f4d03f 0%, #d4af37 100%)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 8px 25px rgba(212,175,55,0.3)';
                  e.target.style.background = 'linear-gradient(135deg, #d4af37 0%, #f4d03f 100%)';
                }}
                onClick={() => navigate('/contact')}
              >
                {t.reserve.button}
              </button>

              {/* Éléments décoratifs */}
              <div
                style={{
                  position: 'absolute',
                  bottom: '30px',
                  left: '50px',
                  display: 'flex',
                  gap: '15px',
                  alignItems: 'center',
                }}
              >
                <div style={{ width: '40px', height: '1px', background: '#d4af37' }} />
                <span style={{ color: '#d4af37', fontSize: '12px', letterSpacing: '2px' }}>
                  EXPÉRIENCE UNIQUE
                </span>
              </div>
            </div>
          </div>

          {/* Right Side - Map avec style moderne */}
          <div
            style={{
              position: 'relative',
              minHeight: '600px',
              background: '#0f0f0f',
              padding: '80px 50px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            {/* Titre de la section map */}
            <div style={{ marginBottom: '40px' }}>
              <div
                style={{
                  width: '60px',
                  height: '3px',
                  background: 'linear-gradient(90deg, #d4af37, transparent)',
                  marginBottom: '20px',
                }}
              />
              <h3
                style={{
                  fontFamily: 'Playfair Display, serif',
                  fontSize: '36px',
                  color: '#fff',
                  marginBottom: '15px',
                }}
              >
                Notre <span style={{ color: '#d4af37' }}>Emplacement</span>
              </h3>
              <p style={{ color: '#888', fontSize: '16px', lineHeight: '1.6' }}>
                Venez nous rendre visite à Tafraoute
              </p>
            </div>

            {/* Map Container avec bordure stylée */}
            <div
              style={{
                position: 'relative',
                height: '400px',
                borderRadius: '15px',
                overflow: 'hidden',
                boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
                border: '2px solid rgba(212,175,55,0.2)',
              }}
            >
              {/* Overlay corners décoratifs */}
              <div
                style={{
                  position: 'absolute',
                  top: '0',
                  left: '0',
                  width: '40px',
                  height: '40px',
                  borderTop: '3px solid #d4af37',
                  borderLeft: '3px solid #d4af37',
                  zIndex: 10,
                }}
              />
              <div
                style={{
                  position: 'absolute',
                  top: '0',
                  right: '0',
                  width: '40px',
                  height: '40px',
                  borderTop: '3px solid #d4af37',
                  borderRight: '3px solid #d4af37',
                  zIndex: 10,
                }}
              />
              <div
                style={{
                  position: 'absolute',
                  bottom: '0',
                  left: '0',
                  width: '40px',
                  height: '40px',
                  borderBottom: '3px solid #d4af37',
                  borderLeft: '3px solid #d4af37',
                  zIndex: 10,
                }}
              />
              <div
                style={{
                  position: 'absolute',
                  bottom: '0',
                  right: '0',
                  width: '40px',
                  height: '40px',
                  borderBottom: '3px solid #d4af37',
                  borderRight: '3px solid #d4af37',
                  zIndex: 10,
                }}
              />

              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3463.5257234595733!2d-8.9597194!3d29.7624364!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xdb6b10011b56089%3A0x5443cde1fee2be0d!2sRiad%20lina!5e0!3m2!1sen!2sma!4v1763645657758!5m2!1sen!2sma"
                width="100%"
                height="100%"
                style={{
                  border: 0,
                  filter: 'grayscale(0.3) contrast(1.1)',
                }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>

            {/* Info supplémentaires */}
            <div
              style={{
                marginTop: '30px',
                padding: '25px',
                background: 'rgba(212,175,55,0.05)',
                borderRadius: '10px',
                border: '1px solid rgba(212,175,55,0.2)',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '15px' }}>
                <div
                  style={{
                    width: '50px',
                    height: '50px',
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, #d4af37, #f4d03f)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '24px',
                  }}
                >
                  📍
                </div>
                <div>
                  <p style={{ color: '#d4af37', fontSize: '14px', marginBottom: '5px' }}>ADRESSE</p>
                  <p style={{ color: '#fff', fontSize: '16px', fontWeight: '600' }}>
                    Tafraoute, Maroc
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Pattern décoratif en background */}
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '600px',
            height: '600px',
            background: 'radial-gradient(circle, rgba(212,175,55,0.03) 0%, transparent 70%)',
            pointerEvents: 'none',
          }}
        />
      </section>
    <br /> <br /> <br />
    {/* Contact Section */}
      <section id="contact" style={{
        padding: '120px 30px',
        background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)',
        color: '#fff'
      }}>
        <div style={{ maxWidth: '900px', margin: '0 auto', textAlign: 'center' }} className="scale-in">
          <h2 style={{
            fontFamily: 'Playfair Display, serif', fontSize: 'clamp(36px, 5vw, 56px)',
            marginBottom: '30px', fontWeight: 700
          }}>
            {t.contact.title}
          </h2>
          <div style={{ width: '100px', height: '3px', background: '#d4af37', margin: '0 auto 60px' }} />
          
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '40px', marginBottom: '50px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px' }}>
              <MapPin size={40} color="#d4af37" />
              <h3 style={{ fontFamily: 'Playfair Display, serif', fontSize: '20px', color: '#d4af37' }}>Adresse</h3>
              <p style={{ fontSize: '16px' }}>{t.contact.address}</p>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px' }}>
              <Phone size={40} color="#d4af37" />
              <h3 style={{ fontFamily: 'Playfair Display, serif', fontSize: '20px', color: '#d4af37' }}>Téléphone</h3>
              <p style={{ fontSize: '16px' }}>{t.contact.phone}</p>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px' }}>
              <Mail size={40} color="#d4af37" />
              <h3 style={{ fontFamily: 'Playfair Display, serif', fontSize: '20px', color: '#d4af37' }}>Email</h3>
              <p style={{ fontSize: '16px' }}>{t.contact.email}</p>
            </div>
          </div>

          <button style={{
            background: 'linear-gradient(135deg, #d4af37, #f9e79f)',
            color: '#000', padding: '18px 50px', fontSize: '18px',
            border: 'none', borderRadius: '50px', cursor: 'pointer',
            fontWeight: 700, letterSpacing: '2px', transition: 'all 0.4s',
             }}
             onClick={() => navigate('/contact')}>
            {t.hero.cta}
          </button>
        </div>
      </section>

    </div>
    );

    };
export default Home;

